import tippy from 'tippy.js'

export default {
  setup() {
    const el = this.el
    this.tooltip = tippy(el, {
      allowHTML: true,
      content(_reference) {
        const template = document.getElementById(`${el.id}-content`)
        return template.innerHTML
      }
    })
  },
  destroy() {
    this.tooltip?.destroy()
    this.tooltip = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
